<template>
  <tr>
    <td class="width">{{ item.name }}</td>
    <td class="width">{{ item.quantity }}</td>
    <td class="width">{{ displayStockInHand }}</td>
    <td class="width">{{ displayStandardQty }}</td>
    <td>
      <input
          v-model="props.item.total_quantity"
          type="number"
          class="form-control text-center"
          :min="0"
      >
      <p class="text-danger mb-0" v-if="item.errorMessage">
        {{ item.errorMessage }}
      </p>
    </td>
  </tr>
</template>

<script setup>
import {computed, inject} from "vue";

const props = defineProps(['item'])
const formData = inject("formData")

const displayStandardQty = computed(() => {
  if (props.item.standard_quantity_including_wastage !== undefined && props.item.standard_quantity_including_wastage !== null) {
    return props.item.standard_quantity_including_wastage
  }

  if (props.item.standard_quantity !== undefined && props.item.standard_quantity !== null) {
    const wastagePercentage = props.item.standard_wastage_percentage || 0
    const wastageQty = (props.item.standard_quantity * wastagePercentage) / 100
    return (parseFloat(props.item.standard_quantity) + wastageQty).toFixed(4)
  }

  const baseQty = props.item.quantity * formData.value.production_quantity
  const wastagePercentage = props.item.wastage || 0
  const wastageQty = (baseQty * wastagePercentage) / 100
  return (baseQty + wastageQty).toFixed(4)
})

const displayStockInHand = computed(() => {
  if (props.item.stockInHand === undefined || props.item.stockInHand === null) {
    return '-'
  }

  return props.item.stockInHand
})

</script>

<style scoped>
.width {
  width: 300px;
}
</style>
